import { ModulePlaceholderList } from '../../components/ModulePlaceholderList';
import { workflowService } from '@kss/api';
import type { Workflow } from '@kss/api';
import type { DataGridColumn } from '@kss/ui';

const columns: DataGridColumn<Workflow>[] = [
  { accessor: 'code', title: 'Code', sortable: true, filterable: true, width: 140 },
  { accessor: 'name', title: 'Name', sortable: true, filterable: true },
  { accessor: 'entityType', title: 'Entity', sortable: true, width: 160 },
  {
    accessor: 'steps',
    title: 'Steps',
    width: 80,
    render: (row: Workflow) => (row.steps?.length ?? 0),
  },
  {
    accessor: 'isActive',
    title: 'Status',
    width: 110,
    render: (row: Workflow) => (row.isActive ? 'Active' : 'Inactive'),
  },
];

export default function AllWorkflows() {
  return (
    <ModulePlaceholderList<Workflow>
      title="Workflows"
      newPath="/panel/workflows/new"
      newLabel="New workflow"
      service={workflowService}
      columns={columns}
    />
  );
}
